<template>
  <!-- 邀约参观详情 -->
  <div class="leader-co-visit-detail record-detail" v-loading="loading">
    <div class="leader-co-visit-info-content">
      <div class="block-content">
        <!-- 协访时间 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_time_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_time_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ formData.visit_time_formCode_FR011 || '-' }}
            </div>
          </span>
        </div>
        <!-- 协访领导 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_leader_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_leader_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ (formData.visit_leader_formCode_FR011 || []).map(item => item.questionItemLabel).join('、') || '-' }}
            </div>
          </span>
        </div>
        <!-- 协访结果 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_result_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_result_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ (formData.visit_result_formCode_FR011 || []).map(item => item.questionItemLabel).join('、') || '-' }}
            </div>
          </span>
        </div>

        <!-- 转长期维护，需要展示长期维护的字段 -->
        <div v-if="((formData.visit_result_formCode_FR011 || [])[0] || {}).questionItemValue === 'S030'">
          <!-- 申请原因 -->
          <div
            v-if="(showFormFieldKeyInfo.apply_reason_formCode_FR006 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.apply_reason_formCode_FR006.zhName }}</span>
              <div class="row-value">
                {{ formData.apply_reason_formCode_FR006 || '-' }}
              </div>
            </span>
          </div>
          <!-- 截止日期 -->
          <div
            v-if="(showFormFieldKeyInfo.expired_formCode_FR006 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.expired_formCode_FR006.zhName }}</span>
              <div class="row-value">
                {{ formData.expired_formCode_FR006 || '-' }}
              </div>
            </span>
          </div>
        </div>
        <!-- 领导意见 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_idea_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_idea_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ formData.visit_idea_formCode_FR011 || '-' }}
            </div>
          </span>
        </div>
        <!-- 协访照片 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_picture_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_picture_formCode_FR011.zhName }}</span>
            <div class="image-list">
              <el-image
                v-for="(img, idx) in formData.visit_picture_formCode_FR011"
                :key="idx"
                :src="img"
                :preview-src-list="formData.visit_picture_formCode_FR011"
                class="info-image"
                fit="cover"
              />
              <div v-if="(formData.visit_picture_formCode_FR011 || []).length === 0" class="empty">暂无协访照片</div>
            </div>
          </span>
        </div>
        <!-- 是否产生费用 -->
        <div
          v-if="(showFormFieldKeyInfo.is_fee_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.is_fee_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ (formData.is_fee_formCode_FR011 || []).map(item => item.questionItemLabel).join('、') || '-' }}
            </div>
          </span>
        </div>
        <!-- 协访费用 -->
        <div
          v-if="(showFormFieldKeyInfo.visit_fee_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.visit_fee_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ formData.visit_fee_formCode_FR011 || '-' }}{{ showFormFieldKeyInfo.visit_fee_formCode_FR011.unit || '' }}
            </div>
          </span>
        </div>
        <!-- 费用明细 -->
        <div
          v-if="(showFormFieldKeyInfo.feed_detail_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.feed_detail_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ formData.feed_detail_formCode_FR011 || '-' }}
            </div>
          </span>
        </div>
        <!-- 上传附件 -->
        <div
          v-if="(showFormFieldKeyInfo.attr_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.attr_formCode_FR011.zhName }}</span>
            <div class="image-list">
              <el-image
                v-for="(img, idx) in formData.attr_formCode_FR011"
                :key="idx"
                :src="img"
                :preview-src-list="formData.attr_formCode_FR011"
                class="info-image"
                fit="cover"
              />
              <div v-if="(formData.attr_formCode_FR011 || []).length === 0" class="empty">暂无附件</div>
            </div>
          </span>
        </div>
        <!-- 医生需求 -->
        <div
          v-if="(showFormFieldKeyInfo.feedback_formCode_FR011 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.feedback_formCode_FR011.zhName }}</span>
            <div class="row-value">
              {{ formData.feedback_formCode_FR011 || '-' }}
            </div>
          </span>
        </div>
        <!-- 期望坐诊医馆 -->
        <!-- <div
          v-if="(showFormFieldKeyInfo.practice_hospital_formCode_FR010 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.practice_hospital_formCode_FR010.zhName }}</span>
            <div class="row-value">
              {{ (formData.practice_hospital_formCode_FR010 || []).map(item => item.questionItemLabel).join('、') || '-' }}
            </div>
          </span>
        </div> -->
        <!-- 期望坐诊时间 -->
        <!-- <div
          v-if="(showFormFieldKeyInfo.practice_time_formCode_FR010 || {}).isShow"
          class="info-row"
        >
          <span class="info-row-item block">
            <span class="row-label">{{ showFormFieldKeyInfo.practice_time_formCode_FR010.zhName }}</span>
            <div class="row-value">
              {{ (formData.practice_time_formCode_FR010 || []).map(item => item.questionItemLabel).join('、') || '-' }}
            </div>
          </span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const leaderCoVisitFormCode = 'FR011'
// const doctorWishFormCode = 'FR010'
const transferFormCode = 'FR006'

export default {
  name: 'LeaderCoVisitDetail',
  data() {
    return {
      loading: false,
      originOptionsInfo: {},
      showFormFieldKeyInfo: {},
      formData: {
        /* 协访 */
        help_visit_id_formCode_FR011: '', // 协访id
        visit_time_formCode_FR011: '', // 协访时间
        visit_leader_formCode_FR011: [], // 协访领导
        visit_result_formCode_FR011: [], // 协访结果
        visit_idea_formCode_FR011: '', // 领导意见
        fileIdsOfLeaderCoVisit: [], // 图片id
        visit_picture_formCode_FR011: [], // 图片地址列表
        is_fee_formCode_FR011: '', // 是产生协访费用
        visit_fee_formCode_FR011: '', // 协访费用
        feed_detail_formCode_FR011: '', // 协访费用明细
        attrFileIdsOfLeaderCoVisit: [], // 上传附件图片id
        attr_formCode_FR011: [], // 上传附件
        feedback_formCode_FR011: '', // 医生需求

        /* 期望 */
        // doctor_expectation_id_formCode_FR010: '', // 期望id
        // practice_hospital_formCode_FR010: '', // 期望坐诊医馆
        // practice_time_formCode_FR010: '', // 期望坐诊时间
        
        /* 转线索 */
        clue_apply_id_formCode_FR006: '', // 转线索id
        apply_reason_formCode_FR006: '', // 申请原因
        expired_formCode_FR006: '', // 截止日期
      }
    }
  },
  methods: {
    async init(formCodeList) {
      this.loading = true
      try {
        await this.getFormFieldList(formCodeList)
        // await this.getFormData(formCodeList)
      } catch (error) {
        console.error('获取表单字段配置信息失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      this.formData = formData
      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.currentRecordInfo.doctorStageId,
          stepCode: this.currentRecordInfo.stepCode,
          stepId: this.currentRecordInfo.stepId,
          formCode,
          doctorId: this.currentRecordInfo.doctorId,
          dataType: 'obj',
          interfaceType: 'stepId'
        })
        // console.log('获取详情页面表单页面数据', data)
      
        // 表单获取的数据为空，则初始化表单id
        if (utils.getDataType(data) === 'object' && Object.keys(data.formData).length === 0) {
          continue
        }
        for(const key in data.formData) {
          const item = data.formData[key] || {}
          const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
          if (
            [
            'visit_picture_formCode_FR011',
            'attr_formCode_FR011',
            ].includes(key)
          ) {
            // 协访照片/上传附件
            const pictureList = valueList
            formData[key] = pictureList.map(item => this.imageBaseUrl + item)
          } else {
            if ([1, 2].includes(item.inputType)) {
              // 单选/多选
              formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
            } else {
              formData[key] = valueList[0] || formData[key] || ''
            }
          }
        }
        this.formData = formData
      }
    },
  },
  created() {
    const formCodeList = [
      leaderCoVisitFormCode,
      //doctorWishFormCode,
      transferFormCode
    ]
    this.init(formCodeList)
  },
  props: {
    currentRecordInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
      // return 'https://image.scxinglin.com'
    }
  }
}

</script>

<style scoped lang='less'>
@import '~@/views/DoctorVisitLTC/style/recordDetail.less';
.leader-co-visit-detail {

  .leader-co-visit-info-content {
    max-height: 500px;
    overflow-y: auto;
  }

  .block-content {
    padding: 0 6px;
  }

  .row-label {
    width: 100px !important;
  }
}
</style>